import React from 'react';
import {
    GridPagination,
    gridPageCountSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import { TablePaginationProps } from '@mui/material';
import MuiPagination from '@mui/material/Pagination';
import { createStyleSheet } from 'utils/helpers';

function Pagination({
    page,
    onPageChange,
    className,
}: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    const styles = createStyleSheet({
        root: {
            '& .MuiPagination-ul': {
                gap: '25px',
            },
            '& .MuiButtonBase-root.MuiPaginationItem-root': {
                width: '42px',
                height: '42px',
                margin: 0,
                padding: 0,
                color: (theme) => theme.palette.primary.main,
                backgroundColor: (theme) => theme.palette.primary.contrastText,
                border: '1px solid',
                borderRadius: '10px',
                borderColor: (theme) => theme.palette.primary.main,
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '24px',
                '&:hover': {
                    // backgroundColor: (theme) => theme.palette.primary.dark,
                },
                '&.Mui-selected': {
                    backgroundColor: (theme) => theme.palette.primary.main,
                    color: (theme) => theme.palette.primary.contrastText,
                },
            },
            '& .MuiButtonBase-root, & .MuiPaginationItem-previousNext': {},
            '& .MuiButtonBase-root:not(.Mui-selected, .MuiPaginationItem-previousNext)':
                {
                    // opacity: 0.38,
                },
        },
    });

    return (
        <MuiPagination
            sx={{ ...styles.root }}
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            variant="text"
            shape="rounded"
            onChange={(event, newPage) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onPageChange(event as any, newPage - 1);
            }}
        />
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function CustomPagination(props: any) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default CustomPagination;
